var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-address"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"header"},[_c('van-nav-bar',{attrs:{"title":"添加角色","left-text":"","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }